const CDN_BASE_URL = (process.env.REACT_APP_CDN_BASE_URL || process.env.PUBLIC_URL || "").replace(/\/$/, "");

function buildCharacterVideoUrl(fileName) {
    const path = `/videos/${fileName}`;
    return CDN_BASE_URL ? `${CDN_BASE_URL}${path}` : path;
}

export const CHARACTER_VIDEO_URLS = {
    fu: buildCharacterVideoUrl("fuyuan_PV.mp4"),
    su: buildCharacterVideoUrl("sushiyou_PV.mp4"),
    lu: buildCharacterVideoUrl("luze_PV.mp4"),
    pei: buildCharacterVideoUrl("feiyuxi_PV.mp4")
};
